// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1T3WH","title":"Images90_title__1IDNi","images":"Images90_images__3NsSu"};